import { addErrorNotification, LoyaltyDomainError, LoyaltyDomainSpecificErrorCode, NotificationType } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
export const handleUpdatePasswordApiError = (error, displayText, setValidationResult) => {
    if (error instanceof LoyaltyDomainError) {
        switch (error === null || error === void 0 ? void 0 : error.errorCode) {
            case LoyaltyDomainSpecificErrorCode.InvalidCurrentPassword:
                setValidationResult({
                    isValid: false,
                    validationErrors: {
                        currentPassword: displayText.errorInvalidCurrentPasswordMessage
                    }
                });
                return;
            default:
        }
    }
    addErrorNotification({
        id: getIdForComponentNotification('update-member-password-form', NotificationType.Error, 'failed-to-update-password'),
        messages: [displayText.updatePasswordFailedMessage]
    }, error);
};
